<template>
  <div class="setVerbalTrick">
    <el-dialog
      title="话术分类管理"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      :before-close="close"
    >
      <div class="title">
        <el-button
          size="small"
          type="primary"
          @click="openHandleVerbalTrick('add')"
          >新建</el-button
        >
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="排序号" width="240" align="center">
          <template slot-scope="{ row }">
            <span>{{
              row.sortNum || row.sortNum === 0 ? row.sortNum : "--"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="话术分类" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="200" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="openHandleVerbalTrick('alter', row)"
              >编辑</span
            >
            <span class="blue_Box" @click="handleDelete(row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 新建、编辑话术分类 -->
    <HandleVerbalTrick ref="handleVerbalTrickRef" @refresh="refresh" />
  </div>
</template>

<script>
import {
  getSpeechcraftClassifyListPage,
  delSpeechcraftClassify,
} from "@/api/marketingAdmin/technicalDialogue.js";
import HandleVerbalTrick from "@/views/marketingAdmin/components/handleVerbalTrick.vue";
import myPagination from "@/components/myPagination.vue";
export default {
  components: {
    myPagination,
    HandleVerbalTrick,
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
    };
  },
  methods: {
    // 初始化
    init() {
      this.getSpeechcraftClassifyListPage({ page: 1, limit: 10 });
      this.dialogVisible = true;
    },
    // 删除
    handleDelete(id) {
      this.$confirm("确认要删除该话术分类吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delSpeechcraftClassify({ id }).then((res) => {
            if (res.code === 0) {
              if (this.pageInfo.total >= this.pageInfo.limit) {
                let sum = this.pageInfo.total % this.pageInfo.limit;
                if (sum === 1) {
                  this.pageInfo.page =
                    Number(this.pageInfo.page) === 1
                      ? 1
                      : Number(this.pageInfo.page) - 1;
                }
              }
              this.refresh();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {});
    },
    // 刷新
    refresh() {
      this.getSpeechcraftClassifyListPage({
        page: this.pageInfo.page,
        limit: this.pageInfo.limit,
      });
      this.$parent.refresh();
      this.$parent.getSpeechcraftClassifyListPage({ page: 1, limit: -1 });
    },
    // 添加管理员
    openHandleVerbalTrick(status, payload) {
      this.$refs.handleVerbalTrickRef.init(status, payload);
    },
    async getSpeechcraftClassifyListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getSpeechcraftClassifyListPage({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 关闭
    close() {
      this.dialogVisible = false;
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getSpeechcraftClassifyListPage({
        page: payload,
        limit: this.pageInfo.limit,
      });
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getSpeechcraftClassifyListPage({ page: 1, limit: payload });
    },
  },
};
</script>

<style lang="scss" scoped>
.setVerbalTrick {
  .title {
    margin: 0px 0 10px;
  }
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>